/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactPersonToPartnerV1Dto } from '../models/ContactPersonToPartnerV1Dto';
import type { CreateContactPersonToPartnerV1Dto } from '../models/CreateContactPersonToPartnerV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchContactPersonToPartnerV1Dto } from '../models/PatchContactPersonToPartnerV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonToPartnersService {
  /**
   * @param requestBody
   * @returns ContactPersonToPartnerV1Dto create entity
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1CreateV1(
    requestBody: CreateContactPersonToPartnerV1Dto,
  ): CancelablePromise<ContactPersonToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contact-person-to-partners',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContactPersonToPartnerV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1FindAllV1(): CancelablePromise<
    Array<ContactPersonToPartnerV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-partners',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-partners',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param id contactPersonToPartnerId
   * @returns ContactPersonToPartnerV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1FindOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-partners/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id contactPersonToPartnerId
   * @param requestBody
   * @returns ContactPersonToPartnerV1Dto the update entity
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchContactPersonToPartnerV1Dto,
  ): CancelablePromise<ContactPersonToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contact-person-to-partners/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param id contactPersonToPartnerId
   * @returns ContactPersonToPartnerV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToPartnerControllerV1RemoveOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-partners/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
